import React, { useEffect, useState } from 'react'
import EmptyImg from "../../Dashboard/assets/img/create-project.png";
import DashboardLeftMenu from '../DashboardLeftMenu';
import DashboardHeader from '../../Header/DashboardHeader';
import { NODE_HOST_URL, NODE_HOST_URL_v1 } from '../api/Api';
import Axios from 'axios';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

const QuickReplySummary = () => {
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const username = lStorage?.user?.username

    const { channel, fromdate, todate, submit, mainurl, contextid } = useParams();
    const [ctaReport, setCtaReport] = useState([]);
    const [error, setError] = useState({
        errorStatus: false,
        errorMessage: '',
        bgColor: ''
    });
    const [searchData, setSearchData] = useState("")
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const LIMIT = 10;

    const decodedChannel = decodeURIComponent(channel);
    const decodedFromDate = decodeURIComponent(fromdate);
    const decodedToDate = decodeURIComponent(todate);
    const decodedSubmit = decodeURIComponent(submit);
    const decodedMainUrl = decodeURIComponent(mainurl);



    useEffect(() => {
        if (decodedChannel === "whatsapp") {
            ctaDetailList();
        }
        else if (decodedChannel === "rcs") {
            ctaRcsDetailReport(1);
        }
        else if (decodedChannel === "email") {
            CtaEmailReport();
        }
        else {
            setError({
                errorStatus: true,
                errorMessage: "There is no Channel to show",
                bgColor: 'alert alert-danger'
            })
        }
    }, []);

    const formatDate = (inputDate) => {
        if (!inputDate) return "";

        const date = new Date(inputDate);

        if (isNaN(date)) {
            console.error("Invalid date:", inputDate);
            return "";
        }

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };

    const ctaDetailList = async () => {
        let payload = {
            user_id: userId,
            token: userToken,
            fromdate: formatDate(decodedFromDate),
            todate: formatDate(decodedToDate),
            submit_via: decodedSubmit,
            method: "viewReport"
        }
        try {
            const { data } = await Axios.post(
                `${NODE_HOST_URL_v1}/click_report_download`,
                payload,
                {
                    headers: {
                        authorization: `Bearer ${userToken}`
                    }
                }
            );
            if (data.success) {
                setCtaReport(data.data)
            }
            else {
                setError({
                    errorStatus: true,
                    errorMessage: data.message,
                    bgColor: 'alert alert-danger'
                })
            }
        } catch (error) {
            setError({
                errorStatus: true,
                errorMessage: error?.response?.data?.message,
                bgColor: 'alert alert-danger'
            })
        }
    }

    const ctaRcsDetailReport = async (page = 1) => {
        let arrContext = contextid.split(",");
        let payload = {
            user_id: userId,
            token: userToken,
            fromDate: formatDate(decodedFromDate),
            toDate: formatDate(decodedToDate),
            method: "viewRcsReport",
            contextId: arrContext,
            page: page,       // ADD
            limit: LIMIT,     // ADD
        };

        try {
            const { data } = await Axios.post(
                `${NODE_HOST_URL_v1}/rcsClickReport`,
                payload,
                { headers: { authorization: `Bearer ${userToken}` } }
            );

            if (data.success) {
                setCtaReport(data.data);
                setCurrentPage(page);   // ADD

                // ADD - adjust key based on your API response
                const total = data.totalRecords || data.total || 0;
                setTotalRecords(total);
                setTotalPages(Math.ceil(total / LIMIT));
            } else {
                setError({
                    errorStatus: true,
                    errorMessage: data.message,
                    bgColor: "alert alert-danger",
                });
            }
        } catch (error) {
            setError({
                errorStatus: true,
                errorMessage: error?.response?.data?.message,
                bgColor: "alert alert-danger",
            });
        }
    };


    const CtaEmailReport = async () => {
        let payload = {
            user_id: userId,
            fromdate: formatDate(decodedFromDate),
            todate: formatDate(decodedToDate),
            method: "ViewEmailReport",
            main_url: decodedMainUrl === "null" ? "" : decodedMainUrl
        }
        try {
            const { data } = await Axios.post(
                `${NODE_HOST_URL_v1}/EmailReport`,
                payload,
                {
                    headers: {
                        authorization: `Bearer ${userToken}`
                    }
                }
            );
            if (data.success) {
                setCtaReport(data.data)
            }
            else {
                setError({
                    errorStatus: true,
                    errorMessage: data.message,
                    bgColor: 'alert alert-danger'
                })
            }
        } catch (error) {
            setError({
                errorStatus: true,
                errorMessage: error?.response?.data?.message,
                bgColor: 'alert alert-danger'
            })
        }
    }

    const handleRcsClickReportDownload = async () => {
        let arrContextDownload = contextid.split(",");
        try {
            const endpoint = `${NODE_HOST_URL_v1}/rcsClickReport`;

            const payload = {
                user_id: userId,
                fromDate: formatDate(decodedFromDate),
                toDate: formatDate(decodedToDate),
                method: "viewdownloadReport",
                username: username,
                contextId: arrContextDownload
            };

            const response = await Axios.post(endpoint, payload,
                {
                    responseType: "arraybuffer", // expect binary file
                    headers: {
                        Authorization: `Bearer ${userToken}`, // <-- add token here
                    },
                }
            );

            const blob = new Blob([response.data], {
                type: "text/csv;charset=utf-8;", // assuming CSV, adjust if needed
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "click_report.csv"); // set proper filename
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error(error);
            setError({
                errorStatus: true,
                errorMessage:
                    error?.response?.data?.message ||
                    "Unable to download click report, please try again later",
                bgColor: "alert alert-danger",
            });
        }
    };

    const Pagination = () => {
        if (totalPages <= 1 || decodedChannel !== "rcs") return null;

        const getPageNumbers = () => {
            const pages = [];
            if (totalPages <= 5) {
                for (let i = 1; i <= totalPages; i++) pages.push(i);
            } else {
                if (currentPage <= 3) {
                    pages.push(1, 2, 3, 4, "...", totalPages);
                } else if (currentPage >= totalPages - 2) {
                    pages.push(1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
                } else {
                    pages.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages);
                }
            }
            return pages;
        };

        return (
            <div className="d-flex justify-content-between align-items-center mt-3">
                <small className="text-muted">
                    Page {currentPage} of {totalPages} ({totalRecords} total records)
                </small>
                <nav>
                    <ul className="pagination pagination-sm mb-0">
                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                            <button
                                className="page-link"
                                onClick={() => ctaRcsDetailReport(currentPage - 1)}
                                disabled={currentPage === 1}
                            >
                                &laquo; Prev
                            </button>
                        </li>

                        {getPageNumbers().map((page, index) =>
                            page === "..." ? (
                                <li key={`ellipsis-${index}`} className="page-item disabled">
                                    <span className="page-link">...</span>
                                </li>
                            ) : (
                                <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => ctaRcsDetailReport(page)}
                                        disabled={currentPage === page}
                                    >
                                        {page}
                                    </button>
                                </li>
                            )
                        )}

                        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                            <button
                                className="page-link"
                                onClick={() => ctaRcsDetailReport(currentPage + 1)}
                                disabled={currentPage === totalPages}
                            >
                                Next &raquo;
                            </button>
                        </li>
                    </ul>
                </nav>
            </div>
        );
    };


    return (
        <div className="wrapper">
            <DashboardLeftMenu />
            <div className="main">
                <DashboardHeader />
                <main className="content">
                    <div className="col-auto d-none d-sm-block">
                        <div className='row mb-3'>
                            <div className='col-6'>
                                <h3>
                                    <strong>Quick Reply Summary</strong>{" "}
                                </h3>
                            </div>
                            {decodedChannel === "rcs" &&
                                <div className='col-6'>
                                    <div className="input-group float-right">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"><FontAwesomeIcon icon={faSearch} /></span>
                                        </div>
                                        <input
                                            type="text"
                                            id="searchInput"
                                            name="searchdata"
                                            value={searchData}
                                            onChange={(e) => setSearchData(e.target.value)}
                                            className="form-control"
                                            placeholder="Search"
                                        />
                                    </div>
                                </div>}
                        </div>

                        {decodedChannel === "rcs" &&
                            <div className='row'>
                                <div className='col-6'></div>
                                <div className='col-6'>
                                    <button
                                        type="button"
                                        className="btn btn-warning float-right mb-2"
                                        style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, height: "45px", color: "white" }}
                                        onClick={handleRcsClickReportDownload}
                                    >
                                        Download
                                    </button>
                                </div>
                            </div>}
                    </div>
                    <div className="card">
                        <div className="card-body">
                            <div className="container-fluid p-0">
                                <div className="">
                                    <div className="">
                                        <div className="p-2">
                                            <div className="">
                                                {
                                                    error.errorStatus ?
                                                        <div className={error.bgColor} role="alert">
                                                            <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                                                <span aria-hidden="true">×</span>
                                                            </button>
                                                            <div className="">
                                                                {error.errorMessage}
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                }
                                                <div className=" flex-fill">
                                                    {ctaReport.length > 0 ?
                                                        <>
                                                            <div className="table-responsive">
                                                                <table className="table table-striped table-sm">
                                                                    <thead>
                                                                        <tr>
                                                                            {decodedChannel === "whatsapp" &&
                                                                                <>
                                                                                    <th className=" d-xl-table-cell">Phone Number </th>
                                                                                    <th className=" d-md-table-cell">Country Code</th>
                                                                                    <th className=" d-md-table-cell">IP</th>
                                                                                    {/* <th className=" d-md-table-cell">Sender</th>
                                                                                <th className=" d-md-table-cell">Submit Via</th> */}
                                                                                    <th className=" d-md-table-cell">URL Device</th>
                                                                                    <th className=" d-md-table-cell">Click Count</th>
                                                                                    <th className=" d-xl-table-cell">Created Date / Time </th>
                                                                                </>
                                                                            }
                                                                            {decodedChannel === "rcs" &&
                                                                                <>
                                                                                    <th className=" d-xl-table-cell">Phone Number </th>
                                                                                    <th className=" d-xl-table-cell">Text </th>
                                                                                    <th className=" d-xl-table-cell">Type </th>
                                                                                    <th className=" d-md-table-cell">Count</th>
                                                                                    <th className=" d-md-table-cell">Clicked Time</th>
                                                                                    <th className=" d-md-table-cell">Created Date</th>
                                                                                </>
                                                                            }
                                                                            {decodedChannel === "email" &&
                                                                                <>
                                                                                    <th className=" d-xl-table-cell">Campaign ID </th>
                                                                                    <th className=" d-xl-table-cell">From Email </th>
                                                                                    <th className=" d-xl-table-cell">To Email </th>
                                                                                    <th className=" d-xl-table-cell">Approved Click Count </th>
                                                                                    <th className=" d-xl-table-cell">Rejected Click Count </th>
                                                                                    <th className=" d-md-table-cell">Click Time</th>
                                                                                    <th className=" d-xl-table-cell">IP </th>
                                                                                    <th className=" d-xl-table-cell">Device </th>
                                                                                    {/* <th className=" d-xl-table-cell">City </th> */}
                                                                                </>
                                                                            }

                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {(ctaReport || [])
                                                                            .filter((x) => {
                                                                                if (!searchData) return true;
                                                                                const q = String(searchData).toLowerCase();

                                                                                // pick the correct field for this row
                                                                                const value =
                                                                                    decodedChannel === "whatsapp" ? x?.phone_number :
                                                                                        decodedChannel === "rcs" ? x?.phone_number :
                                                                                            x?.phone_number ?? x?.phone_number;

                                                                                return String(value ?? "").toLowerCase().includes(q);
                                                                            })
                                                                            .map((item, i) => (
                                                                                <tr key={i}>
                                                                                    {decodedChannel === "whatsapp" && (
                                                                                        <>
                                                                                            <td className="d-xl-table-cell">{item.phone_number}</td>
                                                                                            <td className="d-xl-table-cell">{item.country_code}</td>
                                                                                            <td className="d-xl-table-cell">{item.ip}</td>
                                                                                            {/* <td className="d-xl-table-cell">{item.sender}</td>
                                                                                        <td className="d-xl-table-cell">{item.submit_via}</td> */}
                                                                                            <td className="d-xl-table-cell">{item.url_device}</td>
                                                                                            <td className="d-xl-table-cell">{item.url_clickcount}</td>
                                                                                            <td className="d-md-table-cell">{item.created}</td>
                                                                                        </>
                                                                                    )}

                                                                                    {decodedChannel === "rcs" && (
                                                                                        <>
                                                                                            <td className="d-xl-table-cell">{item.mobile}</td>
                                                                                            <td className="d-xl-table-cell">{item.text}</td>
                                                                                            <td className="d-xl-table-cell">{item.type}</td>
                                                                                            <td className="d-xl-table-cell">{item.click_count}</td>
                                                                                            <td className="d-xl-table-cell">
                                                                                                {Array.isArray(item.clicked_times) && item.clicked_times.length > 0 ? (
                                                                                                    item.clicked_times.map((time, index) => (
                                                                                                        <div key={index}>{time}</div>
                                                                                                    ))
                                                                                                ) : (
                                                                                                    <span>-</span>  // show dash if no data
                                                                                                )}
                                                                                            </td>

                                                                                            <td className="d-md-table-cell">{item.created}</td>
                                                                                        </>
                                                                                    )}

                                                                                    {decodedChannel === "email" && (
                                                                                        <>
                                                                                            <td className="d-xl-table-cell">{item?.camp_id}</td>
                                                                                            <td className="d-xl-table-cell">{item?.from_email}</td>
                                                                                            <td className="d-xl-table-cell">{item?.to_email}</td>
                                                                                            <td className="d-xl-table-cell">{item?.approve_clickcount}</td>
                                                                                            <td className="d-xl-table-cell">{item?.reject_clickcount}</td>
                                                                                            <td className="d-xl-table-cell">{item?.url_visit_time}</td>
                                                                                            <td className="d-xl-table-cell">{item?.ip}</td>
                                                                                            <td className="d-xl-table-cell">{item?.url_device}</td>
                                                                                            {/* <td className="d-xl-table-cell">{item?.ip}</td> */}
                                                                                        </>
                                                                                    )}
                                                                                </tr>
                                                                            ))}
                                                                    </tbody>

                                                                </table>
                                                            </div>
                                                            <Pagination />
                                                        </>

                                                        :
                                                        <div className="text-center">
                                                            <div className="card-body">
                                                                <img alt="Empty Data" className="project-empty-img" src={EmptyImg} />
                                                                <p>No Entity ID Yet</p>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    )
}

export default QuickReplySummary
